
export class Guest {
  public userId: number;
  public guestId: number;
  public identityNumber: number;
  public companyID: number;
  public firstName: string;
  public lastName: string;
  public carNo: string;
  public entranceDate: string;
  public exitDate: string;
  public sitesList: Array<string>;
  public inside: number;
  public parkDescription: number;
  public parkNumber: number;
  public parkEntranceDate: string;
  public destinedPark: number;

  constructor(
    guestId?: number,
    identityNumber?: number,
    companyID?: number,
    userId?: number,
    firstName?: string,
    lastName?: string,
    carNo?: string,
    entranceDate?: string,
    exitDate?: string,
    sitesList?: Array<string>,
    inside?: number,
    parkDescription?: number,
    parkEntranceDate?: string,
    parkNumber?: number,
    destinedPark?: number

  ) {
    this.guestId = guestId;
    this.identityNumber = identityNumber;
    this.companyID = companyID;
    this.userId = userId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.carNo = carNo;
    this.entranceDate = entranceDate;
    this.exitDate = exitDate;
    this.sitesList = sitesList;
    this.inside = inside;
    this.parkDescription = parkDescription;
    this.parkEntranceDate = parkEntranceDate;
    this.parkNumber = parkNumber;
    this.destinedPark = destinedPark;
  }
}
